module.exports = __webpack_public_path__ + "static/media/plus-white.4dc4b7eb.svg";